<template>
  <div v-if="displayChatbot && isInline" class="wpr">
    <div class="tooltip-container">
      <button class="chatbot-nav-button btn" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false"
        @click="showChatbot" data-tour-item="emailSignup" v-bind="config.attrs">
        <svg width="40" height="34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 6a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v22a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z" :fill="`url(#a-${config.primary_color})`" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="m15.558 16.48 1.519-4.553h.932l1.52 4.553 4.557 1.518v.931l-4.557 1.518L18.009 25h-.932l-1.52-4.553L11 18.929v-.931l4.558-1.518ZM24.157 10.344 24.939 8h.932l.782 2.344 2.347.782v.931l-2.347.781-.782 2.345h-.932l-.782-2.345-2.347-.781v-.931l2.347-.782Z"
            fill="#fff" />
          <defs>
            <linearGradient :id="`a-${config.primary_color}`" x1="0" y1="0" x2="40" y2="34" gradientUnits="userSpaceOnUse">
              <stop :stop-color="darkerColor" />
              <stop offset=".524" :stop-color="darkerColor" />
              <stop offset="1" :stop-color="config.primary_color" />
            </linearGradient>
          </defs>
        </svg>
      </button>
      <transition name="fade">
        <div v-if="showTooltip" class="custom-tooltip">
          <h3>{{ content.chatbot["tooltip-title"] }}</h3>
          <p>{{ content.chatbot["tooltip-subtitle"] }}</p>
        </div>
      </transition>
    </div>
    <p>&lt; {{ content.chatbot.cta }}</p>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import featureMixin from "@/mixins/featureMixin";
//import ParentComms from "@/classes/ParentComms";

export default {
  name: "chatbotNavButton",
  mixins: [featureMixin],
  data() {
    return {
      featurePath: 'chatbotNavButton',
      showTooltip: false
    }
  },
  computed: {
    ...mapGetters(['content']),
    ...mapGetters('config', ['features']),
    ...mapState('search', ['chatConfig']),
    
    isInline() {
      return this.chatConfig?.inline;
    },

    config() {
      return this.features.chatbot || {};
    },

    displayChatbot() {
      const chatbotEnabled = !!this.chatConfig?.isChatOn;
      const storeId = this.$route.query.storeId;
      return chatbotEnabled && this.chatConfig?.stores?.includes(storeId)
    },

    darkerColor() {
      // Convert hex to RGB, darken it, and convert back to hex
      const color = this.config.primary_color || '#9747ff';
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      
      const darkerR = Math.max(0, r - 40);
      const darkerG = Math.max(0, g - 40);
      const darkerB = Math.max(0, b - 40);
      
      return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
    }
  },
  methods: {
    ...mapActions('search', ['setChatbot']),
    showChatbot() {
      this.setChatbot(true);
    }
  }
}
</script>

<style lang="scss" scoped>
.wpr {
  display: flex;
  align-items: center;

  p {
    font-size: 14px;
    margin-left: 10px;
  }
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.chatbot-nav-button.btn {
  border: none !important;

  .chatbot-icon {
    width: 24px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.custom-tooltip {
  position: absolute;
  top: 100%;
  left: 100%;
  transform: translateX(-45px);
  margin-top: 8px;
  background: #fff;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  width: 268px;
  z-index: 10000;

  @media (max-width: 1024px) {
    display: none;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 12px 0;
    line-height: 1.3;
  }

  p {
    margin: 0;
    line-height: 1.4;
    color: #414141;
  }

  &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 20px;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
  }
}

@media (max-width: 1024px) {
  p {
    display: none;
  }
}
</style>
